module.exports = {
	"components.CameraCardList.alertNoData": "無資料",
	"components.CameraCardList.buttonCancel": "取消",
	"components.CameraCardList.buttonEdit": "編輯",
	"components.CameraCardList.buttonReplay": "回放",
	"components.CameraCardList.buttonSave": "儲存",
	"components.CameraCardList.labeStoreName": "門市",
	"components.CameraCardList.labelPlaceName": "監控點",
	"components.CameraCardList.labelStatus": "狀態",
	"components.ChangePasswordPanel.alertChangePasswordSucess": "変更完了",
	"components.ChangePasswordPanel.alertTokenError": "Token エラー",
	"components.ChangePasswordPanel.buttonRelogin": "再ログイン",
	"components.ChangePasswordPanel.buttonSave": "設定",
	"components.ChangePasswordPanel.labelPassword": "パスワード",
	"components.ChangePasswordPanel.labelPasswordAgain": "パスワード(確認)",
	"components.ChangePasswordPanel.titleChangePassword": "パスワード更新",
	"components.ChangePasswordPanel.warningPasswordsAreDifferent": "パスワードが一致しません、もう一度ご入力ください",
	"components.ChangePasswordPanel.labelOldPassword": "旧パスワード",
	"components.ChangePasswordPanel.labelNewPassword": "新パスワード",
	"components.ChangePasswordPanel.changepassword_form_title": "パスワード変更",
	"components.ChangePasswordPanel.changepassword_form_btnEdit": "確認",
	"components.ChangePasswordPanel.changepassword_form_btnCancel": "取消し",
	"components.DatetimePeriod.labelFrom": "From",
	"components.DatetimePeriod.labelTo": "To",
	"components.GroupListPanel.buttonCreate": "追加",
	"components.Header.backToTheTop": "戻る",
	"components.LoginForm.alertLoginFail": "ログインできません",
	"components.LoginForm.alertSentEmail": "パスワード再発行に関するメールを{email}に送信いたしました。メールをご確認下さい。",
	"components.LoginForm.buttonConfirm": "確認",
	"components.LoginForm.buttonLogin": "ログイン",
	"components.LoginForm.buttonSubmit": "新パスワード",
	"components.LoginForm.labelEmailOrUsername": "メールアドレス又はユーザー名",
	"components.LoginForm.labelForgotPassword": "パスワードをお忘れの方",
	"components.LoginForm.labelRememberMe": "ログイン情報保存する",
	"components.LoginForm.placeholderPassword": "パスワード",
	"components.LoginForm.placeholderUsername": "ユーザー名",
	"components.LoginForm.title": "パスワードをお忘れの方",
	"components.MergeMonitorsModal.buttonCancel": "取消し",
	"components.MergeMonitorsModal.buttonSave": "保存",
	"components.MergeMonitorsModal.labelName": "グループ名設定",
	"components.MergeMonitorsModal.labelValue": "監控點列表",
	"components.MonitorSelect.placeholderPleaseSelect": "選択してください",
	"components.RecordCardList.alertChooseTime": "時間を選択してください",
	"components.RecordCardList.alertCreateChart": "チャート追加",
	"components.RecordCardList.alertNodata": "この期間のデータはありません。ほかの期間を指定してください",
	"components.RecordCardList.buttonBarChart": "棒グラフ",
	"components.RecordCardList.buttonDownload": "ダウンロード",
	"components.RecordCardList.buttonLineChart": "折れ線グラフ",
	"components.RecordCardList.buttonLocation": "場所",
	"components.RecordCardList.buttonSubmit": "確認",
	"routes.AccountManagement.components.alertasswordDoesntMatchPleaseEnterAgaian": "パスワードが一致しません、　もう一度ご入力ください",
	"routes.AccountManagement.components.buttonCreate": "新規",
	"routes.AccountManagement.components.buttonSave": "保存",
	"routes.AccountManagement.components.copied": "コピーされました",
	"routes.AccountManagement.components.developerSettings": "開発者設定",
	"routes.AccountManagement.components.generateApiToken": "新Token作成",
	"routes.AccountManagement.components.generateApiTokenDescription": "警告！新tokenを作成した後、旧tokenは無効になります。",
	"routes.AccountManagement.components.generateApiTokenSuccessMessage": "Tokenをすぐコピーして下さい。このページを離れたら再アクセスできません。",
	"routes.AccountManagement.components.labelAuhtorizedDevices": "デバイス権限許可",
	"routes.AccountManagement.components.labelAuhtorizedFeatures": "機能権限許可",
	"routes.AccountManagement.components.labelEmail": "email",
	"routes.AccountManagement.components.labelPassword": "パスワード",
	"routes.AccountManagement.components.labelPleaseEnterPasswordAgain": "パスワードを再入力して下さい",
	"routes.AccountManagement.components.labelUsername": "アカウント",
	"routes.AccountManagement.components.linkNotification": "通知設定",
	"routes.AccountManagement.components.linkSetting": "アカウント変更",
	"routes.AccountManagement.components.linkSubuser": "サブユーザ管理",
	"routes.AccountManagement.components.posDeviceTokens": "POS device tokens",
	"routes.AccountManagement.components.roleAdminNotSupportSubuserFeatureMessage": "Adminはサブユーザー機能サポートしません。他の管理者でログインして下さい。",
	"routes.AccountManagement.components.tdDelete": "削除",
	"routes.AccountManagement.components.tdEdit": "編集",
	"routes.AccountManagement.components.thAuthDevices": "デバイス権限許可",
	"routes.AccountManagement.components.thEmail": "Email",
	"routes.AccountManagement.components.thUsername": "ユーザー名",
	"routes.AccountManagement.components.title": "ユーザー管理",
	"routes.AccountManagement.components.titleCreateSubuser": "新規サブユーザ",
	"routes.AccountManagement.components.titleDeveloperSettings": "開発者設定",
	"routes.AccountManagement.components.titleEditSubuser": "サブユーザ編集",
	"components.Header.logout": "ログアウト",
	"components.Header.back": "エリアモニタリング",
	"components.Header.headerMenuUserManagement": "ユーザー管理",
	"components.Header.headerMenuBedManagement": "ベッド管理",
	"components.Header.headerMenuPatientManagement": "入居者管理",
	"components.Header.headerMenuAreaMonitoring": "エリアモニタリング",
	"components.Header.headerMenuChangePassword": "パスワード変更",
	"components.Header.headerMenuHistoryQuery": "履歴検索",
	"components.Header.headerMenuSetting": "システム設定",
	"components.Header.headerMenuVideoWall": "ベッドモニタリング",
	"routes.PatientMonitoring.components.areaMonitoring": "エリアモニタリング",
	"routes.PatientMonitoring.components.realtimeMonitoring": "リアルタイム状態",
	"routes.PatientMonitoring.components.realtimeImage": "リアルタイム画像",
	"routes.PatientMonitoring.components.HistorySearching": "履歴検索",
	"routes.PatientMonitoring.components.bedAlarmSetting": "アラート設定",
	"routes.PatientMonitoring.components.bedSetting": "ベッド設定",
	"routes.PatientMonitoring.components.fullScreen": "全画面表示",
	"routes.PatientMonitoring.components.CloseFullScreen": "全画面終了",
	"routes.PatientMonitoring.components.keyWard": "部屋：",
	"routes.PatientMonitoring.components.keyBed": "ベッド：",
	"routes.PatientMonitoring.components.keyPatientId": "入居者No.：",
	"routes.PatientMonitoring.components.patientId": "入居者No.：",
	"routes.PatientMonitoring.components.keyPatientName": "名前：",
	"routes.PatientMonitoring.components.keyMonitorDate": "入居日：",
	"routes.PatientMonitoring.components.keyDateOfBirth": "生年月日：",
	"routes.PatientMonitoring.components.keyBedNo": "ベッドNo.：",
	"routes.PatientMonitoring.components.labelName": "期間",
	"routes.PatientMonitoring.components.labelTo": "～",
	"routes.PatientMonitoring.components.bedcard_state_hr_warm": "心率異常",
	"routes.PatientMonitoring.components.bedcard_state_rr_warm": "呼吸異常",
	"routes.PatientMonitoring.components.bedcard_state_temp_warm": "體溫異常",
	"routes.PatientMonitoring.components.bedcard_state_warm": "體徵異常",
	"routes.PatientMonitoring.components.bedcard_state_offbed": "離床",
	"routes.PatientMonitoring.components.bedcard_state_onbed": "在床",
	"routes.PatientMonitoring.components.bedcard_state_getup": "起身",
	"routes.PatientMonitoring.components.bedcard_state_offline": "設備離線",
	"routes.PatientMonitoring.components.bedcard_state_move": "翻動",
	"routes.PatientMonitoring.components.buttonSearch": "検索",
	"routes.PatientMonitoring.components.placeholderPleaseSelect": "クイック検索",
	"routes.PatientMonitoring.components.threeDays": "3日間",
	"routes.PatientMonitoring.components.oneWeek": "1週間",
	"routes.PatientMonitoring.components.oneMonth": "1か月間",
	"routes.PatientMonitoring.components.keyHeartRate": "心拍",
	"routes.PatientMonitoring.components.keyRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.keyTemperature": "体温",
	"routes.PatientMonitoring.components.keyMovement": "寝返り",
	"routes.PatientMonitoring.components.onBed": "臥床",
	"routes.PatientMonitoring.components.notOnBed": "離床",
	"routes.PatientMonitoring.components.avg": "平均",
	"routes.PatientMonitoring.components.rrBpm": "回/分",
	"routes.PatientMonitoring.components.heartBpm": "回/分",
	"routes.PatientMonitoring.components.patientmonitoringloading": "読み込み中",
	"routes.PatientMonitoring.components.QuickSearchTitleHeartRate": "心拍",
	"routes.PatientMonitoring.components.QuickSearchTitleRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.QuickSearchTitleTemperature": "体温",
	"routes.PatientMonitoring.components.QuickSearchTitleMovement": "寝返り",
	"routes.PatientMonitoring.components.QuickSearchTitleToday": "今日",
	"routes.PatientMonitoring.components.QuickSearchTitleThreeDay": "直近3日間",
	"routes.PatientMonitoring.components.QuickSearchTitleSevenDay": "直近7日間",
	"routes.PatientMonitoring.components.HistoryTitleHeartRate": "心拍",
	"routes.PatientMonitoring.components.HistoryTitleRespiratoryRate": "呼吸",
	"routes.PatientMonitoring.components.HistoryTitleTemperature": "体温",
	"routes.PatientMonitoring.components.HistoryTitleMovement": "寝返り",
	"routes.PatientMonitoring.components.history_bedno": "ベッドNo.",
	"routes.PatientMonitoring.components.lastSixtyMins": "直近60分間",
	"routes.PatientMonitoring.components.history_timerange": "時間範囲",
	"routes.PatientMonitoring.components.history_nodata": "データなし",
	"routes.PatientMonitoring.components.TrendData": "履歴",
	"routes.PatientMonitoring.components.history_query": "検索",
	"routes.PatientMonitoring.components.bedsetting_form_btnCreate": "新規",
	"routes.PatientMonitoring.components.bedsetting_form_btnDelete": "削除",
	"routes.PatientMonitoring.components.bedsetting_form_btnEdit": "確認",
	"routes.PatientMonitoring.components.bedsetting_form_btnCancel": "取消し",
	"routes.PatientMonitoring.components.bedsetting_form_tagRoomInfo": "ベッド情報",
	"routes.PatientMonitoring.components.bedsetting_form_tagPatientInfo": "入居者情報",
	"routes.PatientMonitoring.components.bedsetting_form_RoomNo": "部屋名",
	"routes.PatientMonitoring.components.bedsetting_form_BedNo": "ベッド名",
	"routes.PatientMonitoring.components.bedsetting_form_name": "名前",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnEdit": "確認",
	"routes.PatientMonitoring.components.bedAlarmSetting_btnCancel": "取消し",
	"routes.PatientMonitoring.components.bedAlarmSetting_tagState": "姿勢アラート",
	"routes.PatientMonitoring.components.bedAlarmSetting_tagVitalSign": "バイタルサインアラート",
	"routes.PatientMonitoring.components.bedAlarmSetting_duration": "続く期間",
	"routes.PatientMonitoring.components.bedAlarmSetting_title": "ベッド通知設定",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleTemp": "体温",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleRR": "呼吸",
	"routes.PatientMonitoring.components.bedAlarmSetting_subTitleHR": "心拍",
	"routes.VideoWall.components.bedSetting": "ベッド設定",
	"routes.VideoWall.components.bedAlarmSetting": "アラート設定",
	"routes.VideoWall.components.areaMonitoring": "エリアモニタリング",
	"routes.VideoWall.components.realtimeMonitoring": "リアルタイムモニタリング",
	"routes.VideoWall.components.realtimeImage": "リアルタイム画像",
	"routes.VideoWall.components.HistorySearching": "履歴検索",
	"routes.VideoWall.components.videoWall": "ベッドモニタリング",
	"routes.VideoWall.components.patientmonitoringloading": "読み込み中",
	"routes.VideoWall.components.keyHeartRate": "心拍",
	"routes.VideoWall.components.keyRespiratoryRate": "呼吸",
	"routes.VideoWall.components.keyTemperature": "体温",
	"routes.BedSetting.components.bedManagement": "ベッド管理",
	"routes.BedSetting.components.bedsetting_bedno": "ベッドNo.",
	"routes.BedSetting.components.bedsetting_roomno": "部屋No.",
	"routes.BedSetting.components.bedsetting_area": "エリア",
	"routes.BedSetting.components.bedsetting_type": "タイプ",
	"routes.BedSetting.components.bedsetting_user": "ユーザー",
	"routes.BedSetting.components.bedsetting_state": "状態",
	"routes.BedSetting.components.bedsetting_operation": "操作",
	"routes.BedSetting.components.bedsetting_addNewRoom": "新規部屋",
	"routes.BedSetting.components.bedsetting_addNewBed": "新規ベッド",
	"routes.BedSetting.components.bedsetting_addNewArea": "新規エリア",
	"routes.BedSetting.components.bedsetting_form_addNewAreaTitle": "エリア追加",
	"routes.BedSetting.components.bedsetting_form_addNewRoomTitle": "部屋追加",
	"routes.BedSetting.components.bedsetting_form_addNewBedTitle": "ベッド追加",
	"routes.BedSetting.components.bedsetting_form_roomName": "部屋名",
	"routes.BedSetting.components.bedsetting_form_bedKey": "ベッドコード",
	"routes.BedSetting.components.bedsetting_form_bedName": "ベッド名",
	"routes.BedSetting.components.bedsetting_form_roomtype": "部屋タイプ",
	"routes.BedSetting.components.bedsetting_form_roomNo": "部屋No.",
	"routes.BedSetting.components.bedsetting_form_roomstate": "状態",
	"routes.BedSetting.components.bedsetting_form_operation": "操作",
	"routes.BedSetting.components.bedsetting_form_area": "エリア",
	"routes.BedSetting.components.bedsetting_form_keySixA": "(一般)6人部屋",
	"routes.BedSetting.components.bedsetting_form_keyThreeB": "(ホスピス)3人部屋",
	"routes.BedSetting.components.bedsetting_form_keyThreeC": "(呼吸ケア)3人部屋",
	"routes.BedSetting.components.bedsetting_form_keyThreeD": "(特殊)3人部屋",
	"routes.BedSetting.components.bedsetting_form_areaTitle": "新規部屋/エリア",
	"routes.BedSetting.components.bedsetting_form_roomTitle": "新規ベッド/部屋",
	"routes.BedSetting.components.bedsetting_form_bedTitle": "新規ベッド",
	"routes.BedSetting.components.bedsetting_form_areaName": "エリア名",
	"routes.BedSetting.components.bedsetting_form_areaNo": "エリア番号",
	"routes.BedSetting.components.bedsetting_form_btnCreate": "新規",
	"routes.BedSetting.components.bedsetting_form_btnDelete": "削除",
	"routes.BedSetting.components.bedsetting_form_btnEdit": "確認",
	"routes.BedSetting.components.bedsetting_form_btnCancel": "取消し",
	"routes.PatientManagement.components.patientManagement": "入居者管理",
	"routes.SystemSetting.components.SystemSetting": "システム設定",
	"routes.SystemSetting.components.systemsetting_form_user_buttonCreate": "新規",
	"routes.SystemSetting.components.systemsetting_form_user_buttonEdit": "編集",
	"routes.SystemSetting.components.systemsetting_form_user_buttonCancel": "取消し",
	"routes.SystemSetting.components.systemsetting_form_account": "アカウント",
	"routes.SystemSetting.components.systemsetting_form_username": "ユーザー名",
	"routes.SystemSetting.components.systemsetting_form_password": "パスワード",
	"routes.SystemSetting.components.systemsetting_form_usertype": "種類",
	"routes.SystemSetting.components.systemsetting_form_keyUser": "ユーザー",
	"routes.SystemSetting.components.systemsetting_form_keyAdmin": "管理者",
	"routes.SystemSetting.components.systemsetting_form_keySysadmin": "システム管理者",
	"routes.SystemSetting.components.systemsetting_alarm_setting": "警報管理",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCreate": "新規",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonEdit": "編集",
	"routes.SystemSetting.components.systemsetting_form_alarm_buttonCancel": "取消し",
	"routes.SystemSetting.components.systemsetting_form_alarm_setting": "警報追加",
	"routes.SystemSetting.components.systemsetting_form_alarm_area": "警報エリア",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyAll": "全部",
	"routes.SystemSetting.components.systemsetting_form_alarm_range": "正常範囲",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyHR": "心拍",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyRR": "呼吸",
	"routes.SystemSetting.components.systemsetting_form_alarm_keyTemp": "体温",
	"routes.SystemSetting.components.systemsetting_form_alarm_notify": "通知",
	"routes.SystemSetting.components.systemsetting_form_alarm_duration": "継続時間",
	"routes.SystemSetting.components.systemsetting_form_alarm_notifyThreshold": "閾値",
	"routes.SystemSetting.components.systemsetting_tab_alarm": "警報管理",
	"routes.SystemSetting.components.systemsetting_tab_user": "ユーザー管理",
	"routes.SystemSetting.components.systemsetting_tab_auth": "権限管理",
	"routes.SystemSetting.components.systemsetting_user_addNewUser": "ユーザー追加",
	"routes.SystemSetting.components.systemsetting_alarm_addNewAlarm": "アラーム追加",
	"routes.SystemSetting.components.systemsetting_operation": "操作",
	"routes.MPatientMonitoring.components.patientmonitoringloading": "読み込み中",
	"routes.MPatientMonitoring.components.areaMonitoring": "エリアモニタリング",
	"routes.MPatientMonitoring.components.realtimeMonitoring": "リアルタイムモニタリング",
	"routes.MPatientMonitoring.components.keyTemperature": "体温",
	"routes.MPatientMonitoring.components.keyRespiratoryRate": "呼吸",
	"routes.MPatientMonitoring.components.keyHeartRate": "心拍",
	"routes.MPatientMonitoring.components.lastSixtyMins": "直近60分間"
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/ja.json
// module id = 3470
// module chunks = 6